import api from './api';

/**
 * Invitation Service
 * Handles all invitation-related API calls for the staff portal
 */

/**
 * Get all invitations
 * @param {Object} params - Query parameters (status, page, limit)
 * @returns {Promise<Object>} Invitation list with pagination
 */
export const getInvitations = async (params = {}) => {
  const response = await api.get('/invitations', { params });
  return response;  // Interceptor already unwraps response.data
};

/**
 * Create a new invitation
 * @param {Object} data - Invitation data (email, firstName, lastName)
 * @returns {Promise<Object>} Created invitation with invitation URL
 */
export const createInvitation = async (data: any) => {
  const response = await api.post('/invitations', data);
  return response;  // Interceptor already unwraps response.data
};

/**
 * Validate an invitation token
 * @param {string} token - Invitation token
 * @returns {Promise<Object>} Validation result
 */
export const validateInvitation = async (token: any) => {
  const response = await api.get(`/invitations/validate/${token}`);
  return response;  // Interceptor already unwraps response.data
};

/**
 * Register with invitation token
 * @param {Object} data - Registration data (token, password, firstName, lastName)
 * @returns {Promise<Object>} Registration result with user and token
 */
export const registerWithInvitation = async (data: any) => {
  const response = await api.post('/invitations/register', data);
  return response;  // Interceptor already unwraps response.data
};

/**
 * Delete/revoke an invitation
 * @param {number} id - Invitation ID
 * @returns {Promise<Object>} Deletion result
 */
export const deleteInvitation = async (id: any) => {
  const response = await api.delete(`/invitations/${id}`);
  return response;  // Interceptor already unwraps response.data
};

/**
 * Resend an invitation email
 * @param {number} id - Invitation ID
 * @returns {Promise<Object>} Resend result
 */
export const resendInvitation = async (id: any) => {
  const response = await api.post(`/invitations/${id}/resend`);
  return response;  // Interceptor already unwraps response.data
};

export default {
  getInvitations,
  createInvitation,
  validateInvitation,
  registerWithInvitation,
  deleteInvitation,
  resendInvitation,
};
